import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const countContactsByBoard = async <T extends Record<string, unknown>>({
  data,
  domain,
  headers,
  query,
  signal,
}: FetchRequestArgs): Promise<ReturnType<typeof fetchRequest>> => {
  return fetchRequest<T>({
    data,
    domain,
    endpoint: `/v2/contacts/count`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal,
  });
};
